var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"scroll-top-wrapper"},[_c('span',{staticClass:"scroll-top",on:{"click":function($event){$event.preventDefault();return _vm.scrollTop.apply(null, arguments)}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }